import { emitter } from '@flowus/common';
import { createPersistStore } from '@flowus/common/zustand/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDrawerOpenStateValue } from 'src/views/main/drawer/shared';

interface IState {
  width: number;
}
export const defaultDrawerWidth = 380;
export const minDefaultDrawerWidth = defaultDrawerWidth - 30;
const $drawerView = createPersistStore<IState>('$drawerView', () => ({
  width: defaultDrawerWidth,
}));

export const useDrawerViewWidth = () => {
  const drawerView = $drawerView((state) => state);
  const [defauleWidth, setDefaultWidth] = useState(defaultDrawerWidth);

  useEffect(() => {
    const listener = (data: any) => {
      if (typeof data === 'number') {
        setDefaultWidth(data);
      } else {
        setDefaultWidth(defaultDrawerWidth);
      }
    };
    emitter.on('aiPageWidth', listener);
    return () => {
      emitter.off('aiPageWidth', listener);
    };
  }, []);

  const setDrawerWidth = useCallback(
    (width: number) =>
      $drawerView.setState((state) => {
        return { ...state, width };
      }),
    []
  );

  return useMemo(() => {
    return {
      drawerWidth: Math.max(drawerView.width, defauleWidth),
      setDrawerWidth,
    };
  }, [drawerView.width, setDrawerWidth, defauleWidth]);
};
